import React from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';

import { BodyComponent } from '../body-component';

interface IPickerAspectsUpdateDialog {
  showDialog: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  confirmLabel: string;
  cancelLabel: string;
}

export const PickerAspectsUpdateDialog = ({
  showDialog,
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
}: IPickerAspectsUpdateDialog) => {
  const { formatMessage } = useIntl();

  const heading = formatMessage({ id: 'productDetailResetHeading' });
  const content = formatMessage({ id: 'productDetailResetContent' });

  return showDialog ? (
    <ConfirmDialog
      showDialog={showDialog}
      modalAppearanceEventMessage="Confirmation: Picker Aspect will Reset Customizations to Default"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  ) : null;
};
